require('./gateways-form.scss')

module.exports = {
  template: require('./gateways-form.pug')()
  controller: require('./gateways-form.ctrl')
  bindings:
    gateway: '<'
    onSubmit: '&'
}
